// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__34Yxz","right":"styles_right__2xRBC"};